// 无header，无footer
import React, { Suspense, ReactNode } from 'react';
import cx from 'classnames';
import cs from './index.module.scss';
import FullPageLoading from '@/components/fullPageLoading';

interface Props {
  children: ReactNode;
}

const PageLayout: React.FC<Props> = ({ children }) => (
  <div className={cx('custom-scrollbar', cs.container)}>
    <div className={cx('content', cs.content)}>
      <Suspense fallback={<FullPageLoading />}>{children}</Suspense>
    </div>
  </div>
);

export default PageLayout;
